import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLogin from './admin/AdminLogin';
import SuperAdminLogin from './super-admin/SuperAdminLogin';
import SuperAdminDashboard from './super-admin/SuperAdminDashboard';
import CandidateRegistrationForm from './admin/CandidateRegistrationForm';
import CandidateList from './admin/CandidateList';
import NotFound from './pages/NotFound';
import StandardLayout from './pages/StandarLayout';
import AdminMenuBar from './admin/AdminMenuBar';
import ProtectedRoutes from './utils/ProtectedRoutes';
import AdminList from './super-admin/AdminList';
import AdminRegistrationForm from './super-admin/AdminRegistrationForm';
import SuperAdminSign from './super-admin/SuperAdminSignup';
import CandidateInquiryForm from './admin/EnquiryCandidate';
import CandidateTable from './admin/EnquiryTable';
import ExcelUpload from './super-admin/upload';
import IncomeExpenseManagement from './dashboard/IncomeExpenseManagement';
import IncomeExpenseEntryForm from './dashboard/IncomeExpenseEntryForm';
import MasterPriceList from './admin/MasterPriceList';



function App() {
  return (  
    <Router>
  <Routes>
    {/* Admin routes */}
    <Route element={<ProtectedRoutes role="admin" />}>
      <Route element={<AdminMenuBar />}>
        <Route path="/admin-dashboard" element={<div>Welcome to Admin Dashboard</div>} />
        {/* <Route path="/dashboard" element={<IncomeExpenseManagement />} />         */}
        <Route path="/candidate-form" element={<CandidateRegistrationForm />} />
       <Route path="/candidate-form/:id?" element={<CandidateRegistrationForm />} />
        <Route path="/candidate-list" element={<CandidateList />} />
        <Route path="/enquiry-form" element={<CandidateInquiryForm />} />
        <Route path="/enquiry-list" element={<CandidateTable />} />        
        {/* <Route path="/income-expenses" element={<IncomeExpenseEntryForm />} />     */}
        <Route path="/master-price-list" element={<MasterPriceList />} />    
      </Route>
    </Route>

    <Route path="/upload" element={<ExcelUpload />} />  

    {/* SuperAdmin routes */}
    <Route element={<ProtectedRoutes role="superadmin" />}>
      <Route element={<SuperAdminDashboard />}>
        <Route path="/super-admin-dashboard" element={<div>Welcome to Super Admin Dashboard</div>} />
        <Route path="/super-admin-registration" element={<AdminRegistrationForm />} />
        <Route path="/admin-list" element={<AdminList />} />
         <Route path="/candidate-add" element={<CandidateRegistrationForm />} />
        <Route path="/overall-list" element={<CandidateList />} />
      </Route>
    </Route>



    {/* Public routes */}
    <Route path="/" element={<StandardLayout><AdminLogin /></StandardLayout>} />
    <Route path="/super-admin" element={<StandardLayout><SuperAdminLogin /></StandardLayout>} />
    <Route path="/superadmin-sign" element={<SuperAdminSign />} />

    {/* 404 */}
    <Route path="*" element={<StandardLayout><NotFound /></StandardLayout>} />
  </Routes>
</Router>
  );
}

export default App; 
